<template>
    <div class="row">
        <div v-if="unfinished_entity !== ''" class="col-12 pt-3 text-align-center">
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <h5>{{lang('hi') +' '+ user.firstname}}</h5>
                        <p>{{lang('unfinished_entity_text_start') + ' ' + lang(unfinished_entity) + ', '+ lang('unfinished_entity_text_end')}}</p>
                        <router-link class="btn btn-default btn-lg"
                           :to="{path: !!unfinishedEntityLink?unfinishedEntityLink:'/'}">
                        {{lang('continue')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="col-12 pt-3 text-align-center">
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <h5>{{lang('hi') +' '+ user.firstname}}</h5>
                        <p v-html="lang('select_your_application_to_view_previous_application')"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from "pinia";
    import * as types from "../../stores/constants";
    import DashboardCard from "../../components/dashboard-card.vue";
    import Dashboard from "./dashboard.vue";
    import documentMixin from "../../utils/document-mixin";
    import applicationMixin from "../../utils/application-mixin";
    import navigationMixin from "../../utils/navigation-mixin";
    import useModuleStore from "../../stores";
    import useApplicationStore from "../../stores/application_module";

    export default {
        name: "home.vue",
        components: {Dashboard},
        mixins: [applicationMixin, navigationMixin],
        data() {
            return {
                page_label: 'welcome',
                show_tabs: false,
            }
        },
        metaInfo() {
            return {
                title: this.lang('home')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => vm.setAppPageTitle(vm.page_label))
        },
        created: function () {
            if (!this.merchant_user_access.hasOwnProperty('quote') && !this.merchant_user_access.hasOwnProperty('application')) {

                if (this.isPublicUser) {
                    let alliance_code = this.user.alliance.alliance_code
                    this.$router.push('/applynow/' + alliance_code)
                } else {
                    this.$router.push('/application/add/business/')

                }
            }
            // else if (this.editMode) {
            //     //console.log('we are in business')
            //     let vm = this
            //     let application = vm.merchant_user_access.hasOwnProperty('application') ? vm.merchant_user_access.application.find(obj => {
            //         return obj
            //     }) : {};
            //     //console.log('app', application.application_reference)
            //
            //     // if (application)
            //     //     this.$router.push(`/application/edit/${application.application_reference}/documents/`)
            // }
        },
        computed: {
            ...mapState(useModuleStore,{
                user:'user',
                merchant_user_access:'merchant_user_access',
                dashboard:'dashboard'}),
            /*unfinished_application: function (){
                //return this.$parent.unfinished_application;
                 return this.dashboard.unfinished.hasOwnProperty('application') &&
                    this.objectIsNotEmpty(this.dashboard.unfinished.application) ? this.dashboard.unfinished.application : {};
            },
            unfinished_quote: function (){
                //return this.$parent.unfinished_quote;
                 return this.dashboard.unfinished.hasOwnProperty('quote') &&
                   this.objectIsNotEmpty(this.dashboard.unfinished.quote) ? this.dashboard.unfinished.quote : {};
            },
            unfinished_entity: function () {
               // return this.$parent.unfinished_entity
                let entity = '';

                if (this.objectIsNotEmpty(this.unfinished_quote)) {
                    entity = 'quote';
                } else if (this.objectIsNotEmpty(this.unfinished_application)) {
                    entity = 'application';
                }
                return entity;
            },
            unfinishedEntityLink: function () {
               //return this.unfinishedEntityLink;
                let path = '';
                if (this.unfinished_entity === 'quote') {
                    path = '/quote/edit/' + this.unfinished_quote.quote_external_id + '/business/';
                }
                if (this.unfinished_entity === 'application') {
                    //Check that the logged in user is the merchant owner
                    let action = this.unfinished_application.hasOwnProperty('merchant_owner_user_external_id') && this.unfinished_application.merchant_owner_user_external_id === this.user.user_external_id ?
                        'edit' : 'view';

                    path = '/application/' + action + '/' + this.unfinished_application.application_reference + '/business_details/';
                }

                return path;
            },*/
            editMode: function() {
                // console.log('editMode->Open', this.isOpenApplication)
                // console.log('merchant_to_upload', this.merchantToUpload)
                // console.log('merchant_control', this.hasMerchantControl)
                return ( this.isOpenApplication && this.merchantToUpload && !this.hasMerchantControl )
            },
            hasMerchantControl: function(){
                return ( !!this.applicationPayload.merchant_control && this.applicationPayload.merchant_control === '1' )
            },
            merchantToUpload: function(){
                return ( !!this.applicationPayload.merchant_to_upload_document && this.applicationPayload.merchant_to_upload_document === '1'  )
            },
            applicationPayload: function (){
                let vm = this
                let application = vm.merchant_user_access.hasOwnProperty('application') ? vm.merchant_user_access.application.find(obj => {
                    return obj
                }) : {};

                return application
            }

        },
        methods: {
            ...mapActions(useApplicationStore, [types.SET_APPLICATION_PAGE_TITLE]),
            setAppPageTitle: function (value) {
                //useModuleStore().commit(types.SET_APPLICATION_MODULE + types.SET_APPLICATION_PAGE_TITLE, value);
                useApplicationStore()[types.SET_APPLICATION_PAGE_TITLE](value);
            },
            toggleShowTabs: function (){
                this.show_tabs = !this.show_tabs;
            },
        }
    }
</script>

<style scoped>
    .text-align-center {
        text-align: center;
    }
</style>